import { SET_GLOBAL_MESSAGE } from './constants';

export function setGlobalMessage(msg) {
  return {
    type: SET_GLOBAL_MESSAGE,
    msg,
  };
}
